import { motion } from "framer-motion";
import { Moon, Sun, ArrowRight } from "lucide-react";

const ThemeGate = ({ onChoose }) => (
    <div
        className="fixed inset-0 z-[100] flex items-center justify-center bg-navy-950/85 p-6 backdrop-blur-md"
        data-testid="theme-gate"
        role="dialog"
        aria-modal="true"
        aria-label="Choose your experience"
    >
        <motion.div
            initial={{ opacity: 0, y: 26, scale: 0.97 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
            className="w-full max-w-2xl rounded-3xl border border-white/10 bg-navy-900 p-8 shadow-[0_50px_140px_-30px_rgba(0,184,240,0.35)] md:p-12"
        >
            <img src="/logo-horizontal.webp" alt="Varasun Technologies" className="h-9 w-auto" />
            <p className="eyebrow mt-9">Welcome to Varasun</p>
            <h2 className="mt-3 font-display text-2xl font-bold tracking-tight text-white md:text-3xl">
                Choose Your Experience
            </h2>
            <p className="mt-2.5 text-sm leading-relaxed text-silver-400">
                The entire site adapts instantly. You can switch anytime from the navigation bar.
            </p>

            <div className="mt-9 grid gap-4 sm:grid-cols-2">
                <button
                    onClick={() => onChoose("dark")}
                    data-testid="theme-option-dark"
                    className="group rounded-2xl border border-white/12 bg-navy-950 p-5 text-left transition-[border-color,transform,box-shadow] duration-300 hover:-translate-y-1 hover:border-electric hover:shadow-[0_24px_60px_-24px_rgba(0,184,240,0.4)]"
                >
                    <div className="relative h-24 overflow-hidden rounded-xl border border-white/10 bg-gradient-to-br from-navy-950 via-navy-900 to-navy-800">
                        <span className="absolute left-3.5 top-3.5 h-2 w-12 rounded-full bg-electric/80" />
                        <span className="absolute left-3.5 top-8 h-1.5 w-20 rounded-full bg-white/25" />
                        <span className="absolute left-3.5 top-12 h-1.5 w-14 rounded-full bg-white/15" />
                        <span className="absolute bottom-3.5 right-3.5 h-7 w-7 rounded-lg border border-electric/40 bg-electric/15" />
                    </div>
                    <div className="mt-4 flex items-center justify-between">
                        <div>
                            <p className="flex items-center gap-2 font-display text-base font-semibold text-white">
                                <Moon size={15} className="text-electric" /> Dark Theme
                            </p>
                            <p className="mt-1 text-xs text-silver-500">Midnight Navy · cinematic</p>
                        </div>
                        <ArrowRight size={16} className="text-electric opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
                    </div>
                </button>

                <button
                    onClick={() => onChoose("light")}
                    data-testid="theme-option-light"
                    className="group rounded-2xl border border-white/12 bg-navy-950 p-5 text-left transition-[border-color,transform,box-shadow] duration-300 hover:-translate-y-1 hover:border-electric hover:shadow-[0_24px_60px_-24px_rgba(0,184,240,0.4)]"
                >
                    <div className="relative h-24 overflow-hidden rounded-xl border border-white/10 bg-gradient-to-br from-white via-[#F7FAFC] to-[#EAF1F8]">
                        <span className="absolute left-3.5 top-3.5 h-2 w-12 rounded-full bg-[#0057B8]" />
                        <span className="absolute left-3.5 top-8 h-1.5 w-20 rounded-full bg-[#0F2444]/25" />
                        <span className="absolute left-3.5 top-12 h-1.5 w-14 rounded-full bg-[#0F2444]/15" />
                        <span className="absolute bottom-3.5 right-3.5 h-7 w-7 rounded-lg border border-[#00B8F0]/50 bg-[#00B8F0]/15" />
                    </div>
                    <div className="mt-4 flex items-center justify-between">
                        <div>
                            <p className="flex items-center gap-2 font-display text-base font-semibold text-white">
                                <Sun size={15} className="text-electric" /> Light Theme
                            </p>
                            <p className="mt-1 text-xs text-silver-500">Cloud White · editorial</p>
                        </div>
                        <ArrowRight size={16} className="text-electric opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
                    </div>
                </button>
            </div>
        </motion.div>
    </div>
);

export default ThemeGate;
